import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, Grid, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useCreateBlogCategory } from "../../hooks/blog-categories/useCreateBlogCategory";
import { useUpdateBlogCategory } from "../../hooks/blog-categories/useUpdateBlogCategory";
import FormInput from "../inputs/FormInput";
import LanguageToggle from "../global/LanguageToggle";

const FormAddEditBlogCategory = ({ currentData, isEdit = false, onSubmitSuccess }) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng.startsWith("ar");
    const initialLang = localStorage.getItem("i18nextLng") || i18next.language || "ar";
    const [activeLang, setActiveLang] = useState(initialLang.startsWith("ar") ? "ar" : "en");

    const [titleAr, setTitleAr] = useState("");
    const [titleEn, setTitleEn] = useState("");
    const [image, setImage] = useState(null);

    const { createBlogCategoryMutate, isPending: isCreating } = useCreateBlogCategory();
    const { updateBlogCategoryMutate, isPending: isUpdating } = useUpdateBlogCategory();

    const loadingSubmit = isCreating || isUpdating;

    useEffect(() => {
        if (isEdit && currentData) {
            setTitleAr(currentData?.title?.ar || "");
            setTitleEn(currentData?.title?.en || "");
            setImage(currentData?.image || null);
        }
    }, [isEdit, currentData]);

    const handleImageChange = (e) => {
        const val = e.target.value;
        setImage(val);
    };

    const getImageName = (imageVal) => {
        if (!imageVal) return "";
        if (typeof imageVal === 'string') {
            return imageVal.substr(imageVal.lastIndexOf('/') + 1);
        }
        return imageVal;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            title: { ar: titleAr || titleEn, en: titleEn || titleAr },
            image: getImageName(image),
        };

        if (isEdit) {
            updateBlogCategoryMutate({ id: currentData.id, data: payload });
        } else {
            createBlogCategoryMutate(payload);
        }

        if (onSubmitSuccess) onSubmitSuccess();
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Paper sx={{ p: 3, borderRadius: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <Typography variant="h6">
                        {isEdit ? (isArabic ? "تعديل التصنيف" : "Edit Category") : (isArabic ? "إضافة تصنيف جديد" : "Add New Category")}
                    </Typography>
                    <LanguageToggle activeLang={activeLang} onChange={(lng) => setActiveLang(lng)} showLabel={true} />
                </Box>

                <Grid container spacing={3}>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <FormInput
                            type="file"
                            name="image"
                            labelImage={isArabic ? "الصورة" : "Image"}
                            value={image}
                            onChange={handleImageChange}
                            width={200}
                            height={120}
                        />
                    </Grid>

                    {activeLang === "ar" && (
                        <Grid item xs={12} md={6}>
                            <FormInput label="العنوان (عربي)" placeholder="أدخل العنوان بالعربي" value={titleAr} onChange={(e) => setTitleAr(e.target.value)} required fullWidth />
                        </Grid>
                    )}
                    {activeLang === "en" && (
                        <Grid item xs={12} md={6}>
                            <FormInput label="Title (English)" placeholder="Enter title in English" value={titleEn} onChange={(e) => setTitleEn(e.target.value)} required fullWidth />
                        </Grid>
                    )}
                </Grid>

                <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                    <Button type="submit" variant="contained" disabled={loadingSubmit} sx={{ minWidth: 120 }}>
                        {loadingSubmit ? (isArabic ? "جاري الحفظ..." : "Saving...") : (isArabic ? "حفظ" : "Save")}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default FormAddEditBlogCategory;
